import { render } from "./totalList.vue?vue&type=template&id=1355adc5&scoped=true"
import script from "./totalList.vue?vue&type=script&lang=js"
export * from "./totalList.vue?vue&type=script&lang=js"

import "./totalList.vue?vue&type=style&index=0&id=1355adc5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1355adc5"]])

export default __exports__